module.exports = __webpack_public_path__ + "static/media/2023_54.174b4647.jpg";